<div class="group">
  <ng-container *ngIf="hasGroup && group | async as group; else createOrJoin">
    <div class="header">
      <div class="tab">
        <p class="text-tab" [class.active]="tab === 'group'" (click)="tab = 'group'">
          {{ group.name }}
          <span></span>
        </p>
        <p class="text-tab" [class.active]="tab === 'history'" (click)="goHistory()">
          Historial
          <span></span>
        </p>
        <div class="finish" *ngIf="!isMobile">
          <div class="box-finish">
            <div>
              <img src="/assets/icons/groups/flag-finish.svg" alt="Clock" />
            </div>
            <p>
              Final del evento: &nbsp; <span> {{ dateFinish.text }} </span>
            </p>
          </div>
        </div>
      </div>
      <div class="name" *ngIf="tab === 'group'">
        <div class="title">
          <h2>{{ group.name }}</h2>
          <p>{{ group.users.length }} miembros</p>
        </div>
        <div class="btn-trade">
          <button
            class="td-btn code"
            (click)="copyCode()"
            [ngClass]="{
              'copy-code': isCopy
            }"
          >
            {{ textButtonCopy }}
            <img src="/assets/icons/groups/accept.svg" alt="Copy" *ngIf="isCopy" />
            <img
              class="img-copy"
              src="/assets/icons/news/copy_violet.svg"
              alt="Copy violet"
              *ngIf="isMobile && !isCopy"
            />
          </button>
          <div class="make-trade" *ngIf="!isMobile && dateFinish.daysLeft >= 0">
            <button class="td-btn primary" (click)="makeTrade()">
              <div>
                <img src="/assets/icons/groups/arrow_right.svg" alt="arrow right" />
                <img src="/assets/icons/groups/arrow_left.svg" alt="arrow left" />
              </div>
              Operar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container" *ngIf="tab === 'group'">
      <div class="left">
        <app-crypto [cryptoBalances]="positions" [hiddenBundle]="true"></app-crypto>
      </div>
      <div class="right">
        <h2>Leaderboard</h2>
        <ng-container *ngIf="!loadingLeaderboard; else uploading">
          <ng-container *ngFor="let group of leaderboard | async; index as i">
            <div class="border-top" *ngIf="i > 4 && group.name === groupName"></div>
            <div class="row" *ngIf="i <= 4 || group.name === groupName">
              <div class="tooltip" *ngIf="group.name === groupName">
                <div>Tu posición</div>
                <img src="/assets/icons/groups/pointer.svg" alt="Pointer" />
              </div>
              <div class="pre-thing" [class.group]="group.name === groupName">
                <p>{{ group.rank }}</p>
              </div>
              <div class="box" [class.group]="group.name === groupName">
                <div class="name">
                  <p>{{ group.name }}</p>
                </div>
                <div class="percent">
                  <p class="text">{{ (group.variation | number : '0.1-2') + ' %' }}</p>
                </div>
                <div class="rank">
                  <p class="text">
                    {{ group.rankChange === 0 ? '-' : Math.abs(group.rankChange) }}
                  </p>
                  <img
                    *ngIf="group.rankChange !== 0"
                    [src]="
                      '/assets/icons/groups/' +
                      (group.rankChange > 0 ? 'rank_up.svg' : 'rank_down.svg')
                    "
                    alt="arrow"
                  />
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #uploading>
          <div class="container-loading">
            <div class="loading">
              <div class="circle-loader"></div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="btn-mobile-trade" *ngIf="isMobile && dateFinish.daysLeft >= 0">
        <div class="position">
          <button class="td-btn primary" (click)="makeTrade()">
            <div>
              <img src="/assets/icons/groups/arrow_right.svg" alt="arrow right" />
              <img src="/assets/icons/groups/arrow_left.svg" alt="arrow left" />
            </div>
            Operar
          </button>
        </div>
      </div>
    </div>
    <div class="history" *ngIf="tab === 'history'">
      <div class="title">
        <h2>Historial</h2>
        <app-paginator
          (paginatorChanges)="paginatorChanges($event)"
          [data]="pageHistory"
          [disabled]="disablePaginationButtons"
        ></app-paginator>
      </div>
      <div class="orders">
        <ng-container *ngIf="!loadingHistory; else uploadingHistory">
          <app-activity *ngFor="let order of historyOrders" [activity]="order"></app-activity>
          <div class="not-orders" *ngIf="historyOrders.length === 0">
            <p>Aún no hay órdenes creadas.</p>
          </div>
        </ng-container>
        <ng-template #uploadingHistory>
          <div class="container-loading">
            <div class="loading">
              <div class="circle-loader"></div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-template #createOrJoin>
    <ng-container *ngIf="!loading">
      <div class="create" *ngIf="step === 1">
        <app-onboarding-group (nextStep)="step = $event"></app-onboarding-group>
      </div>
      <div class="create" *ngIf="step === 2">
        <div class="contain">
          <p class="title">Seleccioná una opción para empezar</p>
          <div class="box">
            <p
              class="text"
              (click)="selectAction = 'create'"
              [class.active]="selectAction === 'create'"
            >
              <img src="/assets/icons/groups/plus_create.svg" alt="plus" />
              Crear grupo
            </p>
            <p
              class="text"
              (click)="selectAction = 'join'"
              [class.active]="selectAction === 'join'"
            >
              <img src="/assets/icons/groups/join.svg" alt="join" />
              Sumarme
            </p>
          </div>
          <div class="name">
            <p>{{ selectAction === 'create' ? 'Nombre del grupo' : 'Código del grupo' }}</p>
            <input
              [formControl]="selectAction === 'create' ? name : codeId"
              type="text"
              (input)="showError = false; limitChars()"
              (keydown)="onKeyDown($event)"
            />
            <button
              class="td-btn primary"
              (click)="selectAction === 'create' ? create() : join()"
              [disabled]="(codeId.invalid && selectAction === 'join') || dateClose.daysLeft < 0"
              *ngIf="!isMobile"
            >
              {{ selectAction === 'create' ? 'Crear' : 'Unirme' }}
            </button>
            <div class="alert" *ngIf="selectAction === 'join'">
              <img src="/assets/icons/groups/alert.svg" alt="Alert" />
              <p>Una vez que te unas a un grupo, ya no podrás salir del mismo</p>
            </div>
            <mat-error class="form-error" *ngIf="showError && selectAction === 'create'">
              {{ 'El nombre es requerido y debe tener entre 3 y 15 caracteres.' }}
            </mat-error>
          </div>
          <div class="time" [class.margin]="selectAction === 'join'">
            <div class="box-time">
              <div>
                <img src="/assets/icons/groups/clock.svg" alt="Clock" />
              </div>
              <p>
                Cierre de grupos: &nbsp; <span> {{ dateClose.text }} </span>
              </p>
            </div>
            <p class="text-version" *ngIf="dateClose.daysLeft < 0">
              No te preocupes, podrás jugar en la próxima versión.
            </p>
          </div>
        </div>
        <div class="btn-create">
          <button
            class="td-btn primary"
            (click)="selectAction === 'create' ? create() : join()"
            [disabled]="(codeId.invalid && selectAction === 'join') || dateClose.daysLeft < 0"
            *ngIf="isMobile"
          >
            {{ selectAction === 'create' ? 'Crear' : 'Unirme' }}
          </button>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
